export const formatIDR = (value) => {
  const n = Math.round(Number(value || 0));
  const abs = Math.abs(n);
  const withDots = new Intl.NumberFormat("id-ID").format(abs);
  return `${n < 0 ? "-" : ""}Rp. ${withDots}`;
};

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const periodLabel = (p) => ({
  daily: "Harian",
  weekly: "Mingguan",
  monthly: "Bulanan",
  yearly: "Tahunan",
}[p] || p);
